import MoreOptionsMenu from "src/SharedComponents/MoreOptions/MoreOptions"
import { useState } from "react";
import DeleteTrialDemo from "../DeleteTrialDemo/DeleteTrialDemo";

interface ITrialOrDemoHandler {
    EntitlementId: string,
    ClinicId: string,
    ClinicName: string,
    DistributorId: string,
    DistributorName: string,
    LicenseType: string,
    updatedLicenses: () => void
}
const TrialOrDemoHandler: React.FC<ITrialOrDemoHandler> = ({EntitlementId, DistributorName, LicenseType, DistributorId, updatedLicenses}) => {
    const [deleteEntitlement, setDeleteEntitlement] = useState<boolean>(false);
    return (
        <>
        {
            deleteEntitlement && <DeleteTrialDemo entitlementId={EntitlementId} distributorName={DistributorName}  licenseType={LicenseType} distributorId={DistributorId}  updateLicenses={updatedLicenses} onClose={() => setDeleteEntitlement(false)}/>
        }
            <div className="px-2">
                <MoreOptionsMenu>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li><div className="dropdown-item" style={{color: "#FF0F00"}} key="1" onClick={() => setDeleteEntitlement(true)}>{'Delete'}</div></li>
                    </ul>
                </MoreOptionsMenu>
            </div>
        </>
    )
}
export default TrialOrDemoHandler